import React, { useEffect, useState } from 'react'
import axios from 'axios'
import Scene from '../../Components/DMM/Scene'
import { DMM_API_HOST, DMM_API_KEY } from '../../_Components/Common/common'
import { Pagination } from 'react-bootstrap'

const index = () => {
  const [approveYn, setApproveYn] = useState('P')
  const [pageNumber, setPageNumber] = useState(1)
  const [pageMap, setPageMap] = useState({})
  const [sceneList, setSceneList] = useState([])

  useEffect(() => {
    getScene()
  }, [pageNumber, approveYn])

  const changeApproveYn = value => {
    setApproveYn(value)
    setPageNumber(1)
  }

  const getScene = async n => {
    const isPrivateTab = approveYn === 'private'
    const apiApproveYn = isPrivateTab ? 'all' : approveYn
    const apiPublicYn = isPrivateTab ? 'N' : 'Y'

    await axios
      .get(
        `${DMM_API_HOST}/v4.0.1/scene/pending-approve?approveYn=${apiApproveYn}&publicYn=${apiPublicYn}&pageNumber=${
          n ? n : pageNumber
        }&limit=15`,
        {
          headers: {
            apikey: DMM_API_KEY,
          },
        }
      )
      .then(({ data }) => {
        setSceneList(data.body.list || [])
        setPageMap(data.body.pageMap || {})
      })
      .catch(err => {
        console.error('[scene/pending-approve] error:', err)
      })
  }

  const updateSceneApprove = async (seq, approveYn) => {
    await axios
      .put(
        `${DMM_API_HOST}/v4.0.1/scene/${seq}/approve`,
        { approveYn },
        {
          headers: {
            apikey: DMM_API_KEY,
            token: sessionStorage.getItem('token'),
          },
        }
      )
      .then(() => {
        getScene()
      })
      .catch(err => {
        console.error('[scene/approve] error:', err)
        const msg =
          (err.response && err.response.data && err.response.data.message) ||
          err.message
        window.alert(
          (approveYn === 'Y' ? '승인' : '거절') + ' 실패: ' + msg
        )
      })
  }

  const renderPaging = (pageNumber, pageMap) => {
    let list = []
    let j = 0
    let i = 0

    let test = pageNumber !== 1 ? pageNumber - 1 : 1
    let last =
      pageNumber !== pageMap.pageCount ? pageNumber * 1 + 1 : pageMap.pageCount

    list.push(
      <Pagination.Item
        key="first"
        onClick={() => {
          setPageNumber(test)
        }}
      >
        &laquo;
      </Pagination.Item>
    )

    for (i = pageMap.startPage * 1; i <= pageMap.endPage; i++) {
      let num = pageMap.startPage * 1 + j

      if (num === pageMap.pageNumber * 1) {
        list.push(
          <Pagination.Item key={i} className="active">
            {num}
          </Pagination.Item>
        )
      } else {
        list.push(
          <Pagination.Item
            key={i}
            onClick={() => {
              setPageNumber(num)
            }}
          >
            {num}
          </Pagination.Item>
        )
      }
      j++
    }

    list.push(
      <Pagination.Item
        key="last"
        onClick={() => {
          setPageNumber(last)
        }}
      >
        &raquo;
      </Pagination.Item>
    )
    return <Pagination>{list}</Pagination>
  }

  return (
    <>
      <Scene
        sceneList={sceneList}
        approveYn={approveYn}
        setApproveYn={changeApproveYn}
        updateSceneApprove={updateSceneApprove}
      />
      <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
        {pageMap && pageMap.pageCount ? renderPaging(pageNumber, pageMap) : null}
      </div>
    </>
  )
}

export default index
